export type FeatureFlagsSettingsDto = {
    EnablePortfolioBalancerTab: boolean;
    EnableBalanceHistoryTab: boolean;
    EnableBinanceTab: boolean;
    EnableOptionsOrderBookConnection: boolean;
};

export enum SettingsSource {
    JsonConfigurationProvider = 1,
    AzureAppConfigurationProvider = 2,
}

export type ApplicationSettingsDto = {
    Source: SettingsSource;
    FeatureFlags: FeatureFlagsSettingsDto;
};
